import { ContentContainer } from "@Components/forecast/ContentContainer";
import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import classNames from "classnames";

type Props = {
  disableAnimation?: boolean;
  className?: string;
};

export const Loading = ({ disableAnimation, className = "" }: Props) => {
  const { t } = useTranslations();

  return (
    <ContentContainer>
      <div
        className={classNames(
          "m:flex m:items-center m:justify-center",
          className,
        )}>
        {disableAnimation ? (
          <div className="m:min-w-[300px] m:py-6 m:text-center m:text-neutral-white">
            {t("forecast.loading")}
          </div>
        ) : (
          <div className="m:mx-[25px] m:my-[50px] m:w-11">
            <svg
              className="m:h-full m:w-full m:animate-loading-spinner"
              width="44"
              height="44"
              viewBox="22 22 44 44">
              <circle
                className="m:fill-none m:stroke-warmgrey-100 m:stroke-2 m:opacity-40"
                cx="44"
                cy="44"
                r="20"
              />
              <circle
                className="m:animate-loading-spinner-dash m:fill-none m:stroke-neutral-white m:stroke-2 m:[stroke-linecap:round] m:[stroke-miterlimit:10]"
                cx="44"
                cy="44"
                r="20"
              />
            </svg>
          </div>
        )}
      </div>
    </ContentContainer>
  );
};
